import { Component, ContentChild, EventEmitter, forwardRef, Input, Output, TemplateRef } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StringFormControl } from '@lc/core';
import { MatFormField, MatLabel, MatInput, MatHint, MatError, MatSuffix } from '@angular/material/input';
import { NgTemplateOutlet } from '@angular/common';
import { MatAutocompleteTrigger, MatAutocomplete, MatOption } from '@angular/material/autocomplete';
import { E2eIdDirective } from '@lc/ui/lib/core';
import { Mask } from '../input-masks';
import { InputField } from '../input-field';

@Component({
  selector: 'lc-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutocompleteComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AutocompleteComponent),
      multi: true,
    },
  ],
  imports: [
    MatFormField,
    MatLabel,
    NgTemplateOutlet,
    MatInput,
    FormsModule,
    MatAutocompleteTrigger,
    ReactiveFormsModule,
    MatAutocomplete,
    MatOption,
    MatHint,
    MatError,
    MatSuffix,
    E2eIdDirective,
  ],
})
export class AutocompleteComponent extends InputField {
  @Input()
    autoCompleteOptions: any[];

  @Output()
  readonly optionValue = new EventEmitter();

  @Input()
    isAutocomplete: boolean;

  @Input()
    placeholderText: string;

  isLoading = false;

  @Input()
    label: string;

  @Input()
    placeholder = '';

  @Input()
    readonly = false;

  @Input()
    required = false;

  @Input()
    inputMask: Mask;

  @Input()
    hint: string;

  @Input()
    suffix: string;

  @Input()
    maskDropSpecialCharacters = true; // # choose if mask will drop special character in the model, or not, default value is true

  @Output()
  readonly blur = new EventEmitter<void>();

  @ContentChild('label')
    labelTemplate: TemplateRef<any>;

  @ContentChild('hint')
    hintTemplate: TemplateRef<any>;

  @ContentChild('suffix')
    suffixTemplate: TemplateRef<any>;

  public onBlur() {
    if (this.formControl && this.formControl instanceof StringFormControl) {
      this.formControl.onLostFocus();
    }

    this.blur.emit();
    this.executeOnTouched();
  }

  updateSelection(event) {
    this.optionValue.emit(event);
  }
}
